import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    color: theme.palette.secondary.main,
    fontWeight: 700,
  }
}));

function MaiaText(props) {
  const classes = useStyles();
  return (
    <span className={classes.root} { ...props}>
      maïa Partners
    </span>
  )
}

export default MaiaText;
